module.exports = __webpack_public_path__ + "static/media/venue.d5e5e3dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/venue.svg
// module id = 321
// module chunks = 1